module.exports = __webpack_public_path__ + "static/media/80.62dcc93c.png";